import { useCallback, useState } from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import { Box, Grid } from "@material-ui/core";

import ToolkitTable from "components/Cards/Tables/ToolkitTable";
import IconButtonLoader from "components/Buttons/IconButtonLoader";
import AdhesionTermsDialog from "components/Dialogs/AdhesionTermsDialog";
import { sortableField } from "utils/tables-utils";
import MaskAndValid from "utils/maskAndValid";

const columnModel = (handleTermsView) => [
  sortableField({
    dataField: "NomeLoja",
    text: "Razão Social",
    headerAlign: "center",
  }),
  sortableField({
    dataField: "CNPJLoja",
    text: "CNPJ da Loja",
    headerAlign: "center",
    align: "center",
    formatter: (params) => {
      return MaskAndValid.maskCNPJ(params);
    },
    csvFormatter: (cell) => {
      return MaskAndValid.maskCNPJ(cell);
    },
  }),
  sortableField({
    dataField: "Apelido",
    text: "Nome da Loja",
    headerAlign: "center",
  }),
  sortableField({
    dataField: "NomeModalidade",
    text: "Modalidade",
    headerAlign: "center",
  }),
  sortableField({
    dataField: "Situacao",
    text: "Situação",
    headerAlign: "center",
  }),
  sortableField({
    dataField: "NomeUsuarioAdesao",
    text: "Usuário Adesão",
    headerAlign: "center",
  }),
  sortableField({
    dataField: "DataHoraAdesao",
    text: "Data Hora Adesão",
    align: "center",
    headerAlign: "center",
  }),
  sortableField({
    dataField: "DataHoraDesistencia",
    text: "Data Hora Desistência",
    align: "center",
    headerAlign: "center",
  }),
  {
    dataField: "verTermos",
    headerAlign: "center",
    isDummyField: true,
    text: "Ver Termos",
    sort: false,
    formatter: (cell, row) => (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <IconButtonLoader
          title="Ver Termos"
          size="small"
          onClick={() => handleTermsView(row)}
          icon={
            <Box
              minWidth="2.25rem"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Box
                component="i"
                className="fas fa-file-signature"
                style={{ width: 10, height: 10 }}
              />
            </Box>
          }
          extraStyle={{ width: 10, height: 10 }}
        />
      </div>
    ),
    csvExport: false,
  },
];

const TableTermosAdesao = ({
  dataTable,
  updateList,
  search,
  currentSizePerPage,
  currentPage,
  totalRegistros,
}) => {
  const [storeTermsView, setStoreTermsView] = useState(null);
  const [loading, setLoading] = useState(false);
  const handleTermsView = useCallback((row) => setStoreTermsView(row), []);

  const doSearch = useCallback(async (page, sizePerPage) => {
    setLoading(true);

    await search({ page, sizePerPage });

    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageChange = useCallback(
    (page, sizePerPage) => {
      doSearch(page, sizePerPage);
    },
    [doSearch]
  );

  const handleSizePerPageChange = useCallback(
    (sizePerPage, page) => {
      doSearch(page, sizePerPage);
    },
    [doSearch]
  );

  return (
    <>
      <Grid item xs={12}>
        <ToolkitTable
          keyField="Id"
          dataTable={dataTable?.map((data, index) => ({ ...data, Id: index }))}
          searched={Boolean(dataTable)}
          columnModel={columnModel(handleTermsView)}
          headerTitle={"Gerenciamento de Termos de Adesão"}
          csvFileName="TermosAdesao.csv"
          pagination={{
            options: [25, 50, 100],
            defaultOption: currentSizePerPage,
            totalSize: totalRegistros,
            showTotal: true,
            page: currentPage,
            onPageChange: handlePageChange,
            sizePerPage: currentSizePerPage,
            onSizePerPageChange: handleSizePerPageChange,
          }}
          loading={loading}
          bootstrapTableProps={{
            remote: true,
            onTableChange: () => {},
          }}
          notFoundTitle="Sua pesquisa não encontrou registros correspondentes."
        />
      </Grid>
      {storeTermsView ? (
        <AdhesionTermsDialog
          open={Boolean(storeTermsView)}
          dataStore={storeTermsView}
          handleClose={(updatedData) => {
            updateList(updatedData);
            setStoreTermsView(null);
          }}
          dialogTitle={`Termos de Adesão da loja ${""}`}
        />
      ) : null}
    </>
  );
};

TableTermosAdesao.propTypes = {
  dataTable: PropTypes.array,
  labelDias: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default TableTermosAdesao;
